/**
 * Map loan installment periodicity to text in PT (Portuguese)
 *
 * @param installmentPeriodicity
 * @param installmentPeriodicityAdditionalInfo
 */
export function mapLoanInstallmentPeriodicity(installmentPeriodicity, installmentPeriodicityAdditionalInfo) {
    if (installmentPeriodicity === 'WITHOUT_REGULAR_PERIODICITY') {
        return 'Sem periodicidade regular';
    }
    if (installmentPeriodicity === 'WEEKLY') {
        return 'Semanal';
    }
    if (installmentPeriodicity === 'FORTNIGHTLY') {
        return 'Quinzenal';
    }
    if (installmentPeriodicity === 'MONTHLY') {
        return 'Mensal';
    }
    if (installmentPeriodicity === 'BIMONTHLY') {
        return 'Bimestral';
    }
    if (installmentPeriodicity === 'QUARTERLY') {
        return 'Trimestral';
    }
    if (installmentPeriodicity === 'SEMESTERLY') {
        return 'Semestral';
    }
    if (installmentPeriodicity === 'YEARLY') {
        return 'Anual';
    }
    if (installmentPeriodicity === 'OTHERS') {
        return installmentPeriodicityAdditionalInfo || 'Outro';
    }
    // Unmapped
    return installmentPeriodicity;
}
